

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Link } from "react-router-dom";
// import {
//   FiLinkedin,
//   FiTwitter,
//   FiGithub,
//   FiMail,
//   FiPhone,
//   FiFilter,
//   FiUsers,
//   FiX,
//   FiGlobe,
//   FiAward,
//   FiBook,
//   FiMapPin,
//   FiCalendar,
// } from "react-icons/fi";
// import axios from "axios";

// function Team() {
//   const [team, setTeam] = useState([]);
//   const [filteredTeam, setFilteredTeam] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [selectedDepartment, setSelectedDepartment] = useState("all");
//   const [loading, setLoading] = useState(true);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     fetchTeam();
//   }, []);

//   useEffect(() => {
//     filterTeam();
//   }, [team, selectedDepartment]);

//   const fetchTeam = async () => {
//     try {
//       const response = await axios.get(
//         "https://agri-back-mauve.vercel.app/api/content/public/team"
//       );
//       if (response.data.success) {
//         setTeam(response.data.data);

//         // Extract unique departments
//         const uniqueDepartments = [
//           ...new Set(response.data.data.map((member) => member.team?.department).filter(Boolean)),
//         ];
//         setDepartments(uniqueDepartments);
//       }
//     } catch (error) {
//       console.error("Error fetching team:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filterTeam = () => {
//     if (selectedDepartment === "all") {
//       setFilteredTeam(team);
//     } else {
//       setFilteredTeam(
//         team.filter((member) => member.team?.department === selectedDepartment)
//       );
//     }
//   };

//   const openModal = (member) => {
//     setSelectedMember(member);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setSelectedMember(null);
//     document.body.style.overflow = "unset";
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p>Loading our amazing team...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 pt-16">
//       {/* Hero Section */}
//       <section className="py-20 bg-gradient-to-br from-green-600 to-emerald-700 text-white">
//         <div className="container mx-auto px-4 text-center">
//           <motion.h1
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-4xl md:text-6xl font-bold mb-6"
//           >
//             Our Team
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2 }}
//             className="text-xl md:text-2xl max-w-3xl mx-auto"
//           >
//             Meet the passionate experts dedicated to transforming African
//             agriculture through technology and innovation
//           </motion.p>
//         </div>
//       </section>

//       {/* Team Navigation */}
//       <section className="py-8 bg-white border-b">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col md:flex-row items-center justify-between gap-4">
//             <div className="flex items-center gap-2 text-gray-700">
//               <FiUsers className="w-5 h-5" />
//               <span className="font-semibold">Team Categories:</span>
//             </div>
//             <div className="flex flex-wrap gap-2">
//               <Link
//                 to="/team/management"
//                 className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
//               >
//                 Management Team
//               </Link>
//               <Link
//                 to="/team/consultancy"
//                 className="px-6 py-2 border border-green-600 text-green-600 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-colors"
//               >
//                 Consultancy Team
//               </Link>
//               <Link
//                 to="/team"
//                 className="px-6 py-2 bg-gray-600 text-white rounded-lg font-semibold hover:bg-gray-700 transition-colors"
//               >
//                 All Team
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Department Filters */}
//       <section className="py-8 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//             <div className="flex items-center gap-2">
//               <FiFilter className="text-gray-400" />
//               <span className="font-medium text-gray-700">
//                 Filter by Department:
//               </span>
//             </div>
//             <div className="flex flex-wrap gap-2">
//               <button
//                 className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                   selectedDepartment === "all"
//                     ? "bg-green-600 text-white"
//                     : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                 }`}
//                 onClick={() => setSelectedDepartment("all")}
//               >
//                 All Departments
//               </button>
//               {departments.map((dept) => (
//                 <button
//                   key={dept}
//                   className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                     selectedDepartment === dept
//                       ? "bg-green-600 text-white"
//                       : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                   }`}
//                   onClick={() => setSelectedDepartment(dept)}
//                 >
//                   {dept}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Team Grid */}
//       <section className="py-20">
//         <div className="container mx-auto px-4">
//           {filteredTeam.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="text-gray-400 text-6xl mb-4">👥</div>
//               <h3 className="text-2xl font-bold text-gray-900 mb-2">
//                 No team members found
//               </h3>
//               <p className="text-gray-600">
//                 Try selecting a different department
//               </p>
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
//               {filteredTeam.map((member, index) => (
//                 <motion.div
//                   key={member._id}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                   whileHover={{ y: -5 }}
//                   className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
//                   onClick={() => openModal(member)}
//                 >
//                   {/* Team Member Image */}
//                  {/* Team Member Image */}
// <div className="relative h-64 overflow-hidden bg-gray-100">
//   {member.image ? (
//     <div className="w-full h-full flex items-center justify-center">
//       <img
//         src={member.image}
//         alt={member.team?.name || member.title}
//         className="max-w-full max-h-full object-contain transition-transform duration-300 hover:scale-105"
//       />
//     </div>
//   ) : (
//     <div className="w-full h-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-2xl font-bold">
//       {(member.team?.name || member.title)
//         ?.split(" ")
//         .map((n) => n[0])
//         .join("")}
//     </div>
//   )}
//   <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
//     <div className="opacity-0 hover:opacity-100 transition-opacity duration-300 flex gap-2">
//       {member.team?.socialLinks?.linkedin && (
//         <a
//           href={member.team.socialLinks.linkedin}
//           onClick={(e) => e.stopPropagation()}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
//         >
//           <FiLinkedin className="w-5 h-5 text-gray-700" />
//         </a>
//       )}
//       {member.team?.socialLinks?.twitter && (
//         <a
//           href={member.team.socialLinks.twitter}
//           onClick={(e) => e.stopPropagation()}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
//         >
//           <FiTwitter className="w-5 h-5 text-blue-400" />
//         </a>
//       )}
//     </div>
//   </div>
// </div>

//                   {/* Team Member Info */}
//                   <div className="p-6">
//                     <div className="flex items-center justify-between mb-3">
//                       <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
//                         {member.team?.department || "General"}
//                       </span>
//                       {member.team?.teamType && (
//                         <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
//                           {member.team.teamType}
//                         </span>
//                       )}
//                     </div>

//                     <h3 className="text-xl font-bold text-gray-900 mb-2">
//                       {member.team?.name || member.title}
//                     </h3>

//                     <p className="text-green-600 font-semibold mb-3">
//                       {member.team?.position}
//                     </p>

//                     <p className="text-gray-600 text-sm mb-4 line-clamp-3">
//                       {member.team?.bio || member.description}
//                     </p>

//                     {member.team?.expertise && member.team.expertise.length > 0 && (
//                       <div className="mb-4">
//                         <div className="flex flex-wrap gap-1">
//                           {member.team.expertise.slice(0, 3).map((skill, i) => (
//                             <span
//                               key={i}
//                               className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded"
//                             >
//                               {skill}
//                             </span>
//                           ))}
//                           {member.team.expertise.length > 3 && (
//                             <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">
//                               +{member.team.expertise.length - 3}
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     <div className="flex items-center justify-between text-sm text-gray-500">
//                       {member.team?.email && (
//                         <a
//                           href={`mailto:${member.team.email}`}
//                           onClick={(e) => e.stopPropagation()}
//                           className="hover:text-green-600 transition-colors"
//                         >
//                           <FiMail className="w-4 h-4" />
//                         </a>
//                       )}
//                       <span className="text-xs text-gray-400">
//                         Click for details
//                       </span>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Team Member Modal */}
//       <AnimatePresence>
//         {showModal && selectedMember && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
//             onClick={closeModal}
//           >
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9 }}
//               animate={{ opacity: 1, scale: 1 }}
//               exit={{ opacity: 0, scale: 0.9 }}
//               className="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Modal Header */}
//               <div className="relative">
//                 {/* Cover Image */}
//                 <div className="h-48 bg-gradient-to-r from-green-500 to-emerald-600 rounded-t-2xl"></div>
                
//                 {/* Profile Image */}
//                 <div className="absolute -bottom-16 left-8">
//                   <div className="w-32 h-32 rounded-full border-4 border-white bg-white overflow-hidden shadow-lg">
//                     {selectedMember.image ? (
//                       <img
//                         src={selectedMember.image}
//                         alt={selectedMember.team?.name || selectedMember.title}
//                         className="w-full h-full object-cover"
//                       />
//                     ) : (
//                       <div className="w-full h-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-2xl font-bold">
//                         {(selectedMember.team?.name || selectedMember.title)
//                           ?.split(" ")
//                           .map((n) => n[0])
//                           .join("")}
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Close Button */}
//                 <button
//                   onClick={closeModal}
//                   className="absolute top-4 right-4 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
//                 >
//                   <FiX className="w-6 h-6 text-gray-600" />
//                 </button>
//               </div>

//               {/* Modal Content */}
//               <div className="pt-20 p-8">
//                 {/* Basic Info */}
//                 <div className="mb-8">
//                   <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
//                     <div>
//                       <h2 className="text-3xl font-bold text-gray-900 mb-2">
//                         {selectedMember.team?.name || selectedMember.title}
//                       </h2>
//                       <p className="text-xl text-green-600 font-semibold">
//                         {selectedMember.team?.position}
//                       </p>
//                     </div>
//                     <div className="flex flex-wrap gap-2 mt-4 md:mt-0">
//                       <span className="inline-block bg-green-100 text-green-800 text-sm px-3 py-1 rounded-full">
//                         {selectedMember.team?.department || "General"}
//                       </span>
//                       {selectedMember.team?.teamType && (
//                         <span className="inline-block bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full">
//                           {selectedMember.team.teamType}
//                         </span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Contact & Social Links */}
//                   <div className="flex flex-wrap gap-4 mb-6">
//                     {selectedMember.team?.email && (
//                       <a
//                         href={`mailto:${selectedMember.team.email}`}
//                         className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors"
//                       >
//                         <FiMail className="w-5 h-5" />
//                         <span>{selectedMember.team.email}</span>
//                       </a>
//                     )}
//                     {selectedMember.team?.phone && (
//                       <a
//                         href={`tel:${selectedMember.team.phone}`}
//                         className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors"
//                       >
//                         <FiPhone className="w-5 h-5" />
//                         <span>{selectedMember.team.phone}</span>
//                       </a>
//                     )}
//                     {selectedMember.team?.joinDate && (
//                       <div className="flex items-center gap-2 text-gray-600">
//                         <FiCalendar className="w-5 h-5" />
//                         <span>Joined {formatDate(selectedMember.team.joinDate)}</span>
//                       </div>
//                     )}
//                   </div>

//                   {/* Social Media Links */}
//                   {(selectedMember.team?.socialLinks?.linkedin || 
//                     selectedMember.team?.socialLinks?.twitter || 
//                     selectedMember.team?.socialLinks?.github || 
//                     selectedMember.team?.socialLinks?.website) && (
//                     <div className="flex gap-4 mb-6">
//                       {selectedMember.team.socialLinks.linkedin && (
//                         <a
//                           href={selectedMember.team.socialLinks.linkedin}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
//                           title="LinkedIn"
//                         >
//                           <FiLinkedin className="w-6 h-6 text-gray-700" />
//                         </a>
//                       )}
//                       {selectedMember.team.socialLinks.twitter && (
//                         <a
//                           href={selectedMember.team.socialLinks.twitter}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
//                           title="Twitter"
//                         >
//                           <FiTwitter className="w-6 h-6 text-blue-400" />
//                         </a>
//                       )}
//                       {selectedMember.team.socialLinks.github && (
//                         <a
//                           href={selectedMember.team.socialLinks.github}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
//                           title="GitHub"
//                         >
//                           <FiGithub className="w-6 h-6 text-gray-700" />
//                         </a>
//                       )}
//                       {selectedMember.team.socialLinks.website && (
//                         <a
//                           href={selectedMember.team.socialLinks.website}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
//                           title="Website"
//                         >
//                           <FiGlobe className="w-6 h-6 text-green-600" />
//                         </a>
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 {/* Bio */}
//                 {(selectedMember.team?.bio || selectedMember.description) && (
//                   <div className="mb-8">
//                     <h3 className="text-xl font-semibold text-gray-900 mb-4">About</h3>
//                     <p className="text-gray-600 leading-relaxed">
//                       {selectedMember.team?.bio || selectedMember.description}
//                     </p>
//                   </div>
//                 )}

//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//                   {/* Expertise */}
//                   {selectedMember.team?.expertise && selectedMember.team.expertise.length > 0 && (
//                     <div className="mb-6">
//                       <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
//                         <FiAward className="w-5 h-5 text-green-600" />
//                         Areas of Expertise
//                       </h3>
//                       <div className="flex flex-wrap gap-2">
//                         {selectedMember.team.expertise.map((skill, index) => (
//                           <span
//                             key={index}
//                             className="bg-green-100 text-green-800 px-3 py-2 rounded-lg text-sm font-medium"
//                           >
//                             {skill}
//                           </span>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {/* Languages */}
//                   {selectedMember.team?.languages && selectedMember.team.languages.length > 0 && (
//                     <div className="mb-6">
//                       <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
//                         <FiGlobe className="w-5 h-5 text-blue-600" />
//                         Languages
//                       </h3>
//                       <div className="flex flex-wrap gap-2">
//                         {selectedMember.team.languages.map((language, index) => (
//                           <span
//                             key={index}
//                             className="bg-blue-100 text-blue-800 px-3 py-2 rounded-lg text-sm font-medium"
//                           >
//                             {language}
//                           </span>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 {/* Education */}
//                 {selectedMember.team?.education && selectedMember.team.education.length > 0 && (
//                   <div className="mb-8">
//                     <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
//                       <FiBook className="w-5 h-5 text-purple-600" />
//                       Education
//                     </h3>
//                     <div className="space-y-4">
//                       {selectedMember.team.education.map((edu, index) => (
//                         <div key={index} className="border-l-4 border-purple-500 pl-4 py-2">
//                           <h4 className="font-semibold text-gray-900">{edu.degree}</h4>
//                           <p className="text-gray-600">{edu.institution}</p>
//                           {edu.year && <p className="text-gray-500 text-sm">Year: {edu.year}</p>}
//                           {edu.description && <p className="text-gray-600 text-sm mt-1">{edu.description}</p>}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Experience */}
//                 {selectedMember.team?.experience && selectedMember.team.experience.length > 0 && (
//                   <div className="mb-8">
//                     <h3 className="text-xl font-semibold text-gray-900 mb-4">Professional Experience</h3>
//                     <div className="space-y-6">
//                       {selectedMember.team.experience.map((exp, index) => (
//                         <div key={index} className="border border-gray-200 rounded-lg p-4">
//                           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
//                             <h4 className="font-semibold text-gray-900 text-lg">{exp.position}</h4>
//                             {exp.duration && (
//                               <span className="text-green-600 font-medium text-sm">{exp.duration}</span>
//                             )}
//                           </div>
//                           <p className="text-gray-700 font-medium mb-2">{exp.company}</p>
//                           {exp.description && (
//                             <p className="text-gray-600 text-sm mb-3">{exp.description}</p>
//                           )}
//                           {exp.achievements && exp.achievements.length > 0 && (
//                             <div>
//                               <h5 className="font-medium text-gray-900 text-sm mb-2">Key Achievements:</h5>
//                               <ul className="list-disc list-inside text-gray-600 text-sm space-y-1">
//                                 {exp.achievements.map((achievement, idx) => (
//                                   <li key={idx}>{achievement}</li>
//                                 ))}
//                               </ul>
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Certifications */}
//                 {selectedMember.team?.certifications && selectedMember.team.certifications.length > 0 && (
//                   <div className="mb-8">
//                     <h3 className="text-xl font-semibold text-gray-900 mb-4">Certifications</h3>
//                     <div className="flex flex-wrap gap-2">
//                       {selectedMember.team.certifications.map((cert, index) => (
//                         <span
//                           key={index}
//                           className="bg-orange-100 text-orange-800 px-3 py-2 rounded-lg text-sm font-medium"
//                         >
//                           {cert}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Awards */}
//                 {selectedMember.team?.awards && selectedMember.team.awards.length > 0 && (
//                   <div className="mb-8">
//                     <h3 className="text-xl font-semibold text-gray-900 mb-4">Awards & Recognition</h3>
//                     <div className="space-y-3">
//                       {selectedMember.team.awards.map((award, index) => (
//                         <div key={index} className="flex items-start gap-3">
//                           <FiAward className="w-5 h-5 text-yellow-500 mt-1 flex-shrink-0" />
//                           <div>
//                             <h4 className="font-semibold text-gray-900">{award.name}</h4>
//                             <p className="text-gray-600 text-sm">
//                               {award.organization} {award.year && `• ${award.year}`}
//                             </p>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }

// export default Team;


import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FiLinkedin,
  FiTwitter,
  FiGithub,
  FiMail,
  FiPhone,
  FiFilter,
  FiUsers,
  FiX,
  FiGlobe,
  FiAward,
  FiBook,
  FiMapPin,
  FiCalendar,
} from "react-icons/fi";
import axios from "axios";

function Team() {
  const [team, setTeam] = useState([]);
  const [filteredTeam, setFilteredTeam] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("all");
  const [loading, setLoading] = useState(true);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Predefined consultancy team profiles
  const predefinedConsultants = [
    {
      id: 1,
      name: "Agricultural Value Chain Development",
      icon: "🔄",
      description: "Experts in optimizing agricultural value chains from production to market, enhancing efficiency and profitability across the entire agricultural ecosystem.",
      specializations: [
        "Supply Chain Optimization",
        "Market Linkages",
        "Post-Harvest Management",
        "Value Addition",
        "Market Analysis",
        "Distribution Networks"
      ],
      experience: "15+ years average",
      contactNote: "Contact management for value chain specialists",
      isConsultant: true
    },
    {
      id: 2,
      name: "Agricultural Biotechnology",
      icon: "🧬",
      description: "Specialists in cutting-edge biotechnological applications for crop improvement, genetic engineering, and sustainable agricultural practices.",
      specializations: [
        "Genetic Engineering",
        "Crop Improvement",
        "Biotech Regulations",
        "Research & Development",
        "Molecular Breeding",
        "Bio-safety"
      ],
      experience: "12+ years average",
      contactNote: "Available for biotech consulting projects",
      isConsultant: true
    },
    {
      id: 3,
      name: "Soil and Plant Health",
      icon: "🌱",
      description: "Experts in soil fertility management, plant nutrition, and integrated approaches to maintain optimal soil and plant health for sustainable production.",
      specializations: [
        "Soil Fertility Management",
        "Plant Nutrition",
        "Integrated Pest Management",
        "Soil Conservation",
        "Crop Health Monitoring",
        "Sustainable Practices"
      ],
      experience: "18+ years average",
      contactNote: "Soil health assessment available",
      isConsultant: true
    },
    {
      id: 4,
      name: "Systems Agronomy",
      icon: "🔬",
      description: "Specialists in holistic farming systems, crop management strategies, and integrated agricultural approaches for maximum productivity and sustainability.",
      specializations: [
        "Farming Systems Design",
        "Crop Management",
        "Precision Agriculture",
        "Integrated Farming",
        "Agro-ecology",
        "System Optimization"
      ],
      experience: "14+ years average",
      contactNote: "System design consultations",
      isConsultant: true
    },
    {
      id: 5,
      name: "Program/Project Evaluation",
      icon: "📊",
      description: "Experts in monitoring, evaluation, and impact assessment of agricultural programs and projects to ensure effectiveness and continuous improvement.",
      specializations: [
        "Impact Assessment",
        "Program Evaluation",
        "Performance Metrics",
        "M&E Systems",
        "Data Analysis",
        "Reporting"
      ],
      experience: "16+ years average",
      contactNote: "Project evaluation services",
      isConsultant: true
    },
    {
      id: 6,
      name: "Policy and Regulatory Affairs",
      icon: "⚖️",
      description: "Specialists in agricultural policy development, regulatory frameworks, and government relations to navigate complex agricultural policy landscapes.",
      specializations: [
        "Policy Development",
        "Regulatory Compliance",
        "Government Relations",
        "Policy Analysis",
        "Advocacy Strategies",
        "Legal Frameworks"
      ],
      experience: "20+ years average",
      contactNote: "Policy advisory available",
      isConsultant: true
    },
    {
      id: 7,
      name: "Intellectual Property & Legal",
      icon: "📝",
      description: "Experts in agricultural intellectual property rights, licensing agreements, and legal frameworks to protect innovations and ensure compliance.",
      specializations: [
        "IP Protection",
        "Licensing Agreements",
        "Legal Compliance",
        "Contract Negotiation",
        "Patent Law",
        "Technology Transfer"
      ],
      experience: "15+ years average",
      contactNote: "IP and legal consultations",
      isConsultant: true
    },
    {
      id: 8,
      name: "Advocacy & Communications",
      icon: "📢",
      description: "Specialists in agricultural advocacy, stakeholder engagement, and strategic communications to promote agricultural development and manage issues.",
      specializations: [
        "Stakeholder Engagement",
        "Strategic Communications",
        "Issues Management",
        "Public Relations",
        "Advocacy Campaigns",
        "Media Relations"
      ],
      experience: "13+ years average",
      contactNote: "Communication strategy development",
      isConsultant: true
    }
  ];

  useEffect(() => {
    fetchTeam();
  }, []);

  useEffect(() => {
    filterTeam();
  }, [team, selectedDepartment]);

  const fetchTeam = async () => {
    try {
      const response = await axios.get(
        "https://agri-back-mauve.vercel.app/api/content/public/team"
      );
      if (response.data.success) {
        setTeam(response.data.data);

        // Extract unique departments
        const uniqueDepartments = [
          ...new Set(response.data.data.map((member) => member.team?.department).filter(Boolean)),
        ];
        setDepartments(uniqueDepartments);
      }
    } catch (error) {
      console.error("Error fetching team:", error);
    } finally {
      setLoading(false);
    }
  };

  const filterTeam = () => {
    if (selectedDepartment === "all") {
      setFilteredTeam(team);
    } else {
      setFilteredTeam(
        team.filter((member) => member.team?.department === selectedDepartment)
      );
    }
  };

  const openModal = (member) => {
    setSelectedMember(member);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMember(null);
    document.body.style.overflow = "unset";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p>Loading our amazing team...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-600 to-emerald-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-bold mb-6"
          >
            Our Team
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl max-w-3xl mx-auto"
          >
            Meet the passionate experts dedicated to transforming African
            agriculture through technology and innovation
          </motion.p>
        </div>
      </section>

      {/* Team Navigation */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-gray-700">
              <FiUsers className="w-5 h-5" />
              <span className="font-semibold">Team Categories:</span>
            </div>
            <div className="flex flex-wrap gap-2">
              <Link
                to="/team/management"
                className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
              >
                Management Team
              </Link>
              <Link
                to="/team/consultancy"
                className="px-6 py-2 border border-green-600 text-green-600 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-colors"
              >
                Consultancy Team
              </Link>
              <Link
                to="/team"
                className="px-6 py-2 bg-gray-600 text-white rounded-lg font-semibold hover:bg-gray-700 transition-colors"
              >
                All Team
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Department Filters */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <FiFilter className="text-gray-400" />
              <span className="font-medium text-gray-700">
                Filter by Department:
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              <button
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  selectedDepartment === "all"
                    ? "bg-green-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
                onClick={() => setSelectedDepartment("all")}
              >
                All Departments
              </button>
              {departments.map((dept) => (
                <button
                  key={dept}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                    selectedDepartment === dept
                      ? "bg-green-600 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                  onClick={() => setSelectedDepartment(dept)}
                >
                  {dept}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Management Team Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center"
          >
            Management Team
          </motion.h2>
          
          {filteredTeam.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-gray-400 text-6xl mb-4">👥</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                No team members found
              </h3>
              <p className="text-gray-600">
                Try selecting a different department
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {filteredTeam.map((member, index) => (
                <motion.div
                  key={member._id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ y: -5 }}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
                  onClick={() => openModal(member)}
                >
                  {/* Team Member Image */}
                  <div className="relative h-64 overflow-hidden bg-gray-100">
                    {member.image ? (
                      <div className="w-full h-full flex items-center justify-center">
                        <img
                          src={member.image}
                          alt={member.team?.name || member.title}
                          className="max-w-full max-h-full object-contain transition-transform duration-300 hover:scale-105"
                        />
                      </div>
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-2xl font-bold">
                        {(member.team?.name || member.title)
                          ?.split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </div>
                    )}
                    <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                      <div className="opacity-0 hover:opacity-100 transition-opacity duration-300 flex gap-2">
                        {member.team?.socialLinks?.linkedin && (
                          <a
                            href={member.team.socialLinks.linkedin}
                            onClick={(e) => e.stopPropagation()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
                          >
                            <FiLinkedin className="w-5 h-5 text-gray-700" />
                          </a>
                        )}
                        {member.team?.socialLinks?.twitter && (
                          <a
                            href={member.team.socialLinks.twitter}
                            onClick={(e) => e.stopPropagation()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
                          >
                            <FiTwitter className="w-5 h-5 text-blue-400" />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Team Member Info */}
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                        {member.team?.department || "General"}
                      </span>
                      {member.team?.teamType && (
                        <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                          {member.team.teamType}
                        </span>
                      )}
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {member.team?.name || member.title}
                    </h3>

                    <p className="text-green-600 font-semibold mb-3">
                      {member.team?.position}
                    </p>

                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {member.team?.bio || member.description}
                    </p>

                    {member.team?.expertise && member.team.expertise.length > 0 && (
                      <div className="mb-4">
                        <div className="flex flex-wrap gap-1">
                          {member.team.expertise.slice(0, 3).map((skill, i) => (
                            <span
                              key={i}
                              className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded"
                            >
                              {skill}
                            </span>
                          ))}
                          {member.team.expertise.length > 3 && (
                            <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">
                              +{member.team.expertise.length - 3}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="flex items-center justify-between text-sm text-gray-500">
                      {member.team?.email && (
                        <a
                          href={`mailto:${member.team.email}`}
                          onClick={(e) => e.stopPropagation()}
                          className="hover:text-green-600 transition-colors"
                        >
                          <FiMail className="w-4 h-4" />
                        </a>
                      )}
                      <span className="text-xs text-gray-400">
                        Click for details
                      </span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Consultancy Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Expert Consultancy Team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Access our network of specialized agricultural consultants with decades of combined experience
            </p>
            <div className="bg-green-50 border border-green-200 rounded-2xl p-6 max-w-4xl mx-auto">
              <p className="text-lg text-green-800">
                <strong>Note:</strong> To access our consultancy team and discuss specific project requirements, 
                please contact our management team. We'll connect you with the right experts for your needs.
              </p>
            </div>
          </motion.div>

          {/* Consultancy Team Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {predefinedConsultants.map((consultant, index) => (
              <motion.div
                key={consultant.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                {/* Consultant Icon & Header */}
                <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-8 text-white text-center">
                  <div className="text-6xl mb-4">{consultant.icon}</div>
                  <h3 className="text-xl font-bold mb-2">{consultant.name}</h3>
                  <div className="flex items-center justify-center gap-2 text-green-100">
                    <FiAward className="w-4 h-4" />
                    <span className="text-sm font-medium">{consultant.experience}</span>
                  </div>
                </div>

                {/* Consultant Info */}
                <div className="p-6">
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {consultant.description}
                  </p>

                  {/* Specializations */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                      <FiBook className="w-4 h-4 text-green-500" />
                      Key Specializations
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {consultant.specializations.slice(0, 4).map((skill, i) => (
                        <span
                          key={i}
                          className="bg-green-50 text-green-700 text-xs px-3 py-1.5 rounded-full font-medium border border-green-100"
                        >
                          {skill}
                        </span>
                      ))}
                      {consultant.specializations.length > 4 && (
                        <span className="bg-gray-100 text-gray-600 text-xs px-3 py-1.5 rounded-full font-medium">
                          +{consultant.specializations.length - 4} more
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Contact Information */}
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <div className="flex items-center gap-3 text-sm text-gray-600">
                      <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <FiMail className="w-4 h-4 text-green-600" />
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">Access this expertise</p>
                        <p className="text-xs text-gray-500">{consultant.contactNote}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-20 bg-gradient-to-br from-green-600 to-emerald-700 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-3xl md:text-4xl font-bold mb-6"
            >
              Ready to Work with Our Experts?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-xl mb-8 text-green-100"
            >
              Contact our management team to discuss your project requirements and get matched with the perfect consultants for your agricultural challenges.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            >
              <Link
                to="/contact"
                className="bg-white text-green-600 px-8 py-4 rounded-lg font-semibold hover:bg-green-50 transition-colors flex items-center gap-2"
              >
                <FiMail className="w-5 h-5" />
                Contact Management Team
              </Link>
              <a
                href="tel:+254700000000"
                className="border border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-green-600 transition-colors flex items-center gap-2"
              >
                <FiPhone className="w-5 h-5" />
                Call Us Directly
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Team Member Modal */}
      <AnimatePresence>
        {showModal && selectedMember && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={closeModal}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              className="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="relative">
                {/* Cover Image */}
                <div className="h-48 bg-gradient-to-r from-green-500 to-emerald-600 rounded-t-2xl"></div>
                
                {/* Profile Image */}
                <div className="absolute -bottom-16 left-8">
                  <div className="w-32 h-32 rounded-full border-4 border-white bg-white overflow-hidden shadow-lg">
                    {selectedMember.image ? (
                      <img
                        src={selectedMember.image}
                        alt={selectedMember.team?.name || selectedMember.title}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-2xl font-bold">
                        {(selectedMember.team?.name || selectedMember.title)
                          ?.split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </div>
                    )}
                  </div>
                </div>

                {/* Close Button */}
                <button
                  onClick={closeModal}
                  className="absolute top-4 right-4 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
                >
                  <FiX className="w-6 h-6 text-gray-600" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="pt-20 p-8">
                {/* Basic Info */}
                <div className="mb-8">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-2">
                        {selectedMember.team?.name || selectedMember.title}
                      </h2>
                      <p className="text-xl text-green-600 font-semibold">
                        {selectedMember.team?.position}
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-4 md:mt-0">
                      <span className="inline-block bg-green-100 text-green-800 text-sm px-3 py-1 rounded-full">
                        {selectedMember.team?.department || "General"}
                      </span>
                      {selectedMember.team?.teamType && (
                        <span className="inline-block bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full">
                          {selectedMember.team.teamType}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Contact & Social Links */}
                  <div className="flex flex-wrap gap-4 mb-6">
                    {selectedMember.team?.email && (
                      <a
                        href={`mailto:${selectedMember.team.email}`}
                        className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors"
                      >
                        <FiMail className="w-5 h-5" />
                        <span>{selectedMember.team.email}</span>
                      </a>
                    )}
                    {selectedMember.team?.phone && (
                      <a
                        href={`tel:${selectedMember.team.phone}`}
                        className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors"
                      >
                        <FiPhone className="w-5 h-5" />
                        <span>{selectedMember.team.phone}</span>
                      </a>
                    )}
                    {selectedMember.team?.joinDate && (
                      <div className="flex items-center gap-2 text-gray-600">
                        <FiCalendar className="w-5 h-5" />
                        <span>Joined {formatDate(selectedMember.team.joinDate)}</span>
                      </div>
                    )}
                  </div>

                  {/* Social Media Links */}
                  {(selectedMember.team?.socialLinks?.linkedin || 
                    selectedMember.team?.socialLinks?.twitter || 
                    selectedMember.team?.socialLinks?.github || 
                    selectedMember.team?.socialLinks?.website) && (
                    <div className="flex gap-4 mb-6">
                      {selectedMember.team.socialLinks.linkedin && (
                        <a
                          href={selectedMember.team.socialLinks.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
                          title="LinkedIn"
                        >
                          <FiLinkedin className="w-6 h-6 text-gray-700" />
                        </a>
                      )}
                      {selectedMember.team.socialLinks.twitter && (
                        <a
                          href={selectedMember.team.socialLinks.twitter}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
                          title="Twitter"
                        >
                          <FiTwitter className="w-6 h-6 text-blue-400" />
                        </a>
                      )}
                      {selectedMember.team.socialLinks.github && (
                        <a
                          href={selectedMember.team.socialLinks.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
                          title="GitHub"
                        >
                          <FiGithub className="w-6 h-6 text-gray-700" />
                        </a>
                      )}
                      {selectedMember.team.socialLinks.website && (
                        <a
                          href={selectedMember.team.socialLinks.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition-colors"
                          title="Website"
                        >
                          <FiGlobe className="w-6 h-6 text-green-600" />
                        </a>
                      )}
                    </div>
                  )}
                </div>

                {/* Bio */}
                {(selectedMember.team?.bio || selectedMember.description) && (
                  <div className="mb-8">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">About</h3>
                    <p className="text-gray-600 leading-relaxed">
                      {selectedMember.team?.bio || selectedMember.description}
                    </p>
                  </div>
                )}

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Expertise */}
                  {selectedMember.team?.expertise && selectedMember.team.expertise.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                        <FiAward className="w-5 h-5 text-green-600" />
                        Areas of Expertise
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedMember.team.expertise.map((skill, index) => (
                          <span
                            key={index}
                            className="bg-green-100 text-green-800 px-3 py-2 rounded-lg text-sm font-medium"
                          >
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Languages */}
                  {selectedMember.team?.languages && selectedMember.team.languages.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                        <FiGlobe className="w-5 h-5 text-blue-600" />
                        Languages
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedMember.team.languages.map((language, index) => (
                          <span
                            key={index}
                            className="bg-blue-100 text-blue-800 px-3 py-2 rounded-lg text-sm font-medium"
                          >
                            {language}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Education */}
                {selectedMember.team?.education && selectedMember.team.education.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <FiBook className="w-5 h-5 text-purple-600" />
                      Education
                    </h3>
                    <div className="space-y-4">
                      {selectedMember.team.education.map((edu, index) => (
                        <div key={index} className="border-l-4 border-purple-500 pl-4 py-2">
                          <h4 className="font-semibold text-gray-900">{edu.degree}</h4>
                          <p className="text-gray-600">{edu.institution}</p>
                          {edu.year && <p className="text-gray-500 text-sm">Year: {edu.year}</p>}
                          {edu.description && <p className="text-gray-600 text-sm mt-1">{edu.description}</p>}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Experience */}
                {selectedMember.team?.experience && selectedMember.team.experience.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Professional Experience</h3>
                    <div className="space-y-6">
                      {selectedMember.team.experience.map((exp, index) => (
                        <div key={index} className="border border-gray-200 rounded-lg p-4">
                          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
                            <h4 className="font-semibold text-gray-900 text-lg">{exp.position}</h4>
                            {exp.duration && (
                              <span className="text-green-600 font-medium text-sm">{exp.duration}</span>
                            )}
                          </div>
                          <p className="text-gray-700 font-medium mb-2">{exp.company}</p>
                          {exp.description && (
                            <p className="text-gray-600 text-sm mb-3">{exp.description}</p>
                          )}
                          {exp.achievements && exp.achievements.length > 0 && (
                            <div>
                              <h5 className="font-medium text-gray-900 text-sm mb-2">Key Achievements:</h5>
                              <ul className="list-disc list-inside text-gray-600 text-sm space-y-1">
                                {exp.achievements.map((achievement, idx) => (
                                  <li key={idx}>{achievement}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Certifications */}
                {selectedMember.team?.certifications && selectedMember.team.certifications.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Certifications</h3>
                    <div className="flex flex-wrap gap-2">
                      {selectedMember.team.certifications.map((cert, index) => (
                        <span
                          key={index}
                          className="bg-orange-100 text-orange-800 px-3 py-2 rounded-lg text-sm font-medium"
                        >
                          {cert}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Awards */}
                {selectedMember.team?.awards && selectedMember.team.awards.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Awards & Recognition</h3>
                    <div className="space-y-3">
                      {selectedMember.team.awards.map((award, index) => (
                        <div key={index} className="flex items-start gap-3">
                          <FiAward className="w-5 h-5 text-yellow-500 mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="font-semibold text-gray-900">{award.name}</h4>
                            <p className="text-gray-600 text-sm">
                              {award.organization} {award.year && `• ${award.year}`}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Team;